export const smartFormId = 'cchlDwQOn0jASRlDEzm8';
export const savvyScriptUrl = 'https://cdn.heysavvy.com/wc/savvy.min.js';

export const testimonialSlideId = 'MB9on6HrrjcHR5RBohXG';
export const rightPlaceSlideId = 'kxB6uGyYi2flGjFw8oZJ';
export const activeLearningSlideId = 'P7UxDCpF33BD1Ipp6zbR';
export const onboardingFlowId = 'UkI2pO4KD0xXQLHkN1GG';
export const loggedOutHomepageFlowId = '8UC9Wo157ptNV5U4MJ1Q';
export const educatorsPageFlowId = 'E9OjYp3VBqYRkTzIL45A';
